// Initial tag categories configuration
// This can be used to seed the Firestore collection

export const TAG_CATEGORIES = {
  cuisine: {
    id: 'cuisine',
    label: 'Cuisine',
    order: 1,
    applies_to: ['recipes'],
    tags: [
      { id: 'italian', label: 'Italian', order: 1 },
      { id: 'mexican', label: 'Mexican', order: 2 },
      { id: 'indian', label: 'Indian', order: 3 },
      { id: 'thai', label: 'Thai', order: 4 },
      { id: 'chinese', label: 'Chinese', order: 5 },
      { id: 'japanese', label: 'Japanese', order: 6 },
      { id: 'middle_eastern', label: 'Middle Eastern', order: 7 },
      { id: 'mediterranean', label: 'Mediterranean', order: 8 },
      { id: 'korean', label: 'Korean', order: 9 },
      { id: 'american_comfort', label: 'American Comfort', order: 10 },
      { id: 'british', label: 'British', order: 11 },
      { id: 'greek', label: 'Greek', order: 12 },
      { id: 'vietnamese', label: 'Vietnamese', order: 13 },
      { id: 'african', label: 'African', order: 14 },
      { id: 'caribbean', label: 'Caribbean', order: 15 },
      { id: 'french', label: 'French', order: 16 },
      { id: 'spanish', label: 'Spanish', order: 17 }
    ]
  },
  meal_characteristics: {
    id: 'meal_characteristics',
    label: 'Meal Characteristics',
    order: 2,
    applies_to: ['recipes', 'meal_plans'],
    tags: [
      { id: 'quick', label: 'Quick (under 30 min)', order: 1 },
      { id: 'one_pot', label: 'One-Pot / One-Pan', order: 2 },
      { id: 'batch_cook', label: 'Batch Cook Friendly', order: 3 },
      { id: 'freezer_friendly', label: 'Freezer Friendly', order: 4 },
      { id: 'budget_friendly', label: 'Budget Friendly', order: 5 },
      { id: 'date_night', label: 'Date Night', order: 6 },
      { id: 'crowd_pleaser', label: 'Crowd Pleaser', order: 7 },
      { id: 'lunchbox_friendly', label: 'Lunchbox Friendly', order: 8 },
      { id: 'make_ahead', label: 'Make Ahead', order: 9 },
      { id: 'no_cook', label: 'No-Cook', order: 10 },
      { id: 'bbq_grill', label: 'BBQ / Grill', order: 11 }
    ]
  },
  protein_source: {
    id: 'protein_source',
    label: 'Protein Source',
    order: 3,
    applies_to: ['recipes'],
    tags: [
      { id: 'tofu', label: 'Tofu', order: 1 },
      { id: 'tempeh', label: 'Tempeh', order: 2 },
      { id: 'beans_lentils', label: 'Beans & Lentils', order: 3 },
      { id: 'chickpeas', label: 'Chickpeas', order: 4 },
      { id: 'eggs', label: 'Eggs', order: 5 },
      { id: 'cheese', label: 'Cheese', order: 6 },
      { id: 'nuts_seeds', label: 'Nuts & Seeds', order: 7 },
      { id: 'seitan', label: 'Seitan', order: 8 },
      { id: 'mushrooms', label: 'Mushrooms', order: 9 },
      { id: 'whole_grains', label: 'Whole Grains', order: 10 }
    ]
  },
  dish_type: {
    id: 'dish_type',
    label: 'Dish Type',
    order: 4,
    applies_to: ['recipes'],
    tags: [
      { id: 'pasta_noodles', label: 'Pasta & Noodles', order: 1 },
      { id: 'rice_grains', label: 'Rice & Grains', order: 2 },
      { id: 'curry', label: 'Curry', order: 3 },
      { id: 'stir_fry', label: 'Stir Fry', order: 4 },
      { id: 'soup', label: 'Soup', order: 5 },
      { id: 'stew', label: 'Stew', order: 6 },
      { id: 'salad', label: 'Salad', order: 7 },
      { id: 'tacos_burritos', label: 'Tacos & Burritos', order: 8 },
      { id: 'pizza_flatbread', label: 'Pizza & Flatbread', order: 9 },
      { id: 'burger_sandwich', label: 'Burger & Sandwich', order: 10 },
      { id: 'pie_bake', label: 'Pie & Bake', order: 11 },
      { id: 'roast_dinner', label: 'Roast Dinner', order: 12 },
      { id: 'bowl', label: 'Bowl', order: 13 },
      { id: 'wrap', label: 'Wrap', order: 14 }
    ]
  },
  texture_satisfaction: {
    id: 'texture_satisfaction',
    label: 'Texture / Satisfaction',
    order: 5,
    applies_to: ['recipes'],
    tags: [
      { id: 'hearty_filling', label: 'Hearty & Filling', order: 1 },
      { id: 'light_fresh', label: 'Light & Fresh', order: 2 },
      { id: 'crispy_crunchy', label: 'Crispy / Crunchy', order: 3 },
      { id: 'creamy_comforting', label: 'Creamy & Comforting', order: 4 },
      { id: 'saucy', label: 'Saucy', order: 5 }
    ]
  },
  dietary: {
    id: 'dietary',
    label: 'Dietary',
    order: 6,
    applies_to: ['recipes', 'meal_plans'],
    tags: [
      { id: 'vegan', label: 'Vegan', order: 1 },
      { id: 'gluten_free', label: 'Gluten-Free', order: 2 },
      { id: 'dairy_free', label: 'Dairy-Free', order: 3 },
      { id: 'nut_free', label: 'Nut-Free', order: 4 },
      { id: 'low_carb', label: 'Low-Carb', order: 5 },
      { id: 'high_protein', label: 'High-Protein', order: 6 },
      { id: 'high_fibre', label: 'High-Fibre', order: 7 }
    ]
  },
  family: {
    id: 'family',
    label: 'Family',
    order: 7,
    applies_to: ['recipes', 'meal_plans'],
    tags: [
      { id: 'family_favourite', label: 'Family Favourite', order: 1 },
      { id: 'kid_approved', label: 'Kid-Approved', order: 2 },
      { id: 'hidden_veg', label: 'Hidden Veg', order: 3 },
      { id: 'fussy_eater', label: 'Fussy Eater Friendly', order: 4 },
      { id: 'get_kids_cooking', label: 'Get Kids Cooking', order: 5 }
    ]
  }
}

// Helper to get all tags as a flat array with category info
export function getAllTags() {
  const allTags = []
  Object.values(TAG_CATEGORIES).forEach(category => {
    category.tags.forEach(tag => {
      allTags.push({
        ...tag,
        categoryId: category.id,
        categoryLabel: category.label
      })
    })
  })
  return allTags
}

// Helper to get categories that apply to a specific entity type
export function getCategoriesForEntity(entityType) {
  return Object.values(TAG_CATEGORIES)
    .filter(cat => cat.applies_to.includes(entityType))
    .sort((a, b) => a.order - b.order)
}

export default TAG_CATEGORIES
